(function() {
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (!link) return;

    var navLocation = null;
    var navSection = null;

    if (link.closest('nav.header__nav')) {
      if (link.classList.contains('header-menu-trigger')) return;
      navLocation = 'header';
      var submenu = link.closest('.header__submenu');
      if (submenu) {
        var parentLi = submenu.closest('li.have-submenu');
        if (parentLi) {
          var trigger = parentLi.querySelector('.header-menu-trigger');
          navSection = trigger ? trigger.textContent.trim().replace(/\s+/g, ' ') : 'Dropdown';
        } else {
          navSection = 'Dropdown';
        }
      } else {
        navSection = 'Top Level';
      }
    }
    else if (link.closest('.header-mobile__menu')) {
      navLocation = 'mobile_menu';
      var mobileSubmenu = link.closest('.header-mobile__submenu');
      if (mobileSubmenu) {
        var details = mobileSubmenu.closest('details');
        if (details) {
          var summary = details.querySelector('summary');
          navSection = summary ? summary.textContent.trim().replace(/\s+/g, ' ') : 'Accordion';
        } else {
          navSection = 'Accordion';
        }
      } else {
        navSection = 'Top Level';
      }
    }
    else if (link.closest('footer.footer')) {
      if (link.classList.contains('list-social__link')) return;
      navLocation = 'footer';
      var footerBlock = link.closest('.footer-block--menu');
      if (footerBlock) {
        var heading = footerBlock.querySelector('.footer-block__heading');
        navSection = heading ? heading.textContent.trim() : 'Footer';
      } else {
        var accBlock = link.closest('.footer-acc');
        if (accBlock) {
          var accButton = accBlock.querySelector('.footer-acc__button');
          navSection = accButton ? accButton.textContent.trim().replace(/\s+/g, ' ') : 'Footer';
        } else {
          navSection = 'Footer';
        }
      }
    }

    if (!navLocation) return;

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'navigation_click', {
        nav_location: navLocation,
        nav_section: navSection,
        link_text: link.textContent.trim().replace(/\s+/g, ' '),
        link_url: link.getAttribute('href') || link.href,
        send_to: 'G-GFR795D1FN'
      });
    }
  });
})();
